import React, { useEffect, useRef } from 'react';
import { Box, Text } from '@indeed/ifl-components';
import { usePageFlow } from '../../lib/pageFlow';

const LightApplyIndexPage: React.FC = () => {
    const { goForward, loading, goToStep } = usePageFlow();
    const hasStartedFlow = useRef(false);

    // Use goForward directly - it now handles dynamic navigation and skip logic!
    useEffect(() => {
        // Prevent multiple execution
        if (hasStartedFlow.current || loading) {
            return;
        }

        const startFlow = async () => {
            try {
                hasStartedFlow.current = true;
                console.log('[LightApplyIndex]: Using goForward for intelligent navigation');
                await goForward({ replace: true }); // ✨ With replace: true to avoid back navigation to index
            } catch (error) {
                console.error('[LightApplyIndex]: goForward failed:', error);
                // Fallback to first step in Light Apply flow using flow-aware navigation
                // goToStep automatically preserves search parameters and validates route
                // Use replace: true to avoid adding fallback navigation to history
                await goToStep('/light-apply/contact-info/1', { replace: true });
            }
        };

        void startFlow();
    }, [goForward, loading, goToStep]); // ✅ Updated dependencies for flow-aware navigation

    // Loading state while redirecting
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minBlockSize: '60vh',
                flexDirection: 'column',
                gap: 4,
                maxInlineSize: '400px',
                margin: '0 auto',
                padding: '32px 16px',
            }}
        >
            <Text sx={{ fontSize: 3, fontWeight: 'bold' }}>🔄 ライトアプライを開始中...</Text>
            <Text sx={{ color: 'foreground.secondary', textAlign: 'center' }}>
                簡単応募体験を準備しています
            </Text>
        </Box>
    );
};

export default LightApplyIndexPage;
